export const initialAbility = [
  {
    action: 'read',
    subject: 'nonuser',
  },
]

export const _ = undefined
